// extracted by mini-css-extract-plugin
export default {"mdpregle":"AddUser_mdpregle__2XJMP","rights":"AddUser_rights__dUL9P","rightsBlock":"AddUser_rightsBlock__1MHWc"};